<template>
  <b-form-group
    label="Sayfa Meta Başlığı"
    label-for="metatag_title"
  >
    <validation-provider
      #default="{ errors }"
      name="Sayfa Meta Başlığı"
      rules="required"
    >
      <b-form-input
        id="metatag_title"
        v-model="dataItem.metatag_title"
        placeholder="Sayfa Meta Başlığı"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup, BFormInput,
} from 'bootstrap-vue'
import { required } from '@validations'

export default {
  name: 'MetaTagTitle',
  components: {
    BFormGroup,
    BFormInput,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['serviceCategories/dataItem']
    },
  },
  created() {
    localize('tr')
  },
}
</script>
